const _excluded = ["size"];
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React from "react";
var Swile24 = function Swile24(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement("path", {
      fill: "#000",
      fillRule: "evenodd",
      d: "M26.48 7.33c.7 0 1.28-.47 1.28-1.16 0-.64-.56-1.17-1.28-1.17-.75 0-1.27.51-1.27 1.17 0 .7.55 1.16 1.27 1.16ZM8.04 17c1.95 0 3.57-.85 3.57-2.75 0-1.58-1.4-2.21-3.38-2.6-.09 0-.18-.03-.28-.04l-.3-.06-.06-.01c-.66-.14-1.35-.36-1.35-.96 0-.62.69-.86 1.34-.86.92 0 1.63.41 1.84 1.3l1.84-.5C10.8 8.9 9.33 8.1 7.6 8.1c-1.76 0-3.34.74-3.34 2.56 0 1.76 1.42 2.18 2.91 2.49l.1.02.1.02.14.03c1.09.22 2.05.53 2.05 1.18 0 .74-.81.98-1.53.98-1.01 0-1.8-.47-2.08-1.42L4 14.47C4.49 16.27 6.3 17 8.04 17Zm19.47-8.72v8.66h-2.07V8.28h2.07ZM21.31 17c.59 0 1.66-.23 2.16-1.7a9.05 9.05 0 0 0 .36-2.7v-.22l.01-.08c.07-1.08.2-2.04.6-2.04V8.28c-.62 0-1.74.23-2.26 1.76-.24.76-.3 1.7-.36 2.59v.09l-.01.05-.06.8v.08l-.01.07c-.07.67-.2 1.31-.45 1.31-.23 0-.38-.55-.46-1.16l-.01-.07-.03-.18v-.07l-.01-.07c-.04-.3-.06-.58-.07-.8-.04-.9-.1-1.9-.37-2.66-.49-1.5-1.59-1.74-2.2-1.74-.62 0-1.69.23-2.2 1.74-.24.76-.3 1.76-.35 2.65 0 .23-.03.51-.06.8v.08c-.08.73-.23 1.48-.52 1.48-.29 0-.46-.7-.56-1.38l-.01-.08-.01-.07a10.5 10.5 0 0 1-.08-.83 118 118 0 0 1-.07-4.39h-2v.46c0 1.5 0 2.58.07 3.93.06 1.18.24 2.08.43 2.6C13.16 16.43 13.92 17 15 17c1.07 0 1.92-.67 2.22-1.73a12.57 12.57 0 0 0 .38-2.85l.06-.75v-.07c.08-.67.2-1.33.47-1.33.25 0 .38.6.46 1.23v.07l.01.07.01.07.06.84v.13c.06.9.1 1.83.36 2.6.5 1.5 1.64 1.72 2.25 1.72h.02Zm9.28-4.46c0 1.39.29 2.27 1.02 3.25L29.94 17a6.85 6.85 0 0 1-1.42-4.46V5.23h2.07v7.3ZM35.85 17a3.98 3.98 0 0 0 3.83-2.53l-1.9-.5c-.29.74-.95 1.21-1.88 1.21-1.16 0-2.2-.87-2.25-2.24h6.32c.25-2.58-1.28-4.84-4.13-4.84-2.54 0-4.24 1.94-4.24 4.44C31.6 15 33.3 17 35.85 17Zm-.03-7.22c-1.06 0-1.95.67-2.15 1.64h4.3c-.16-.88-1.02-1.64-2.15-1.64Z",
      clipRule: "evenodd",
    })
  );
};
Swile24.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "44",
  height: "24",
  fill: "none",
  viewBox: "0 0 44 24",
};
var Swile32 = function Swile32(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement("rect", {
      width: "31",
      height: "23",
      x: ".5",
      y: ".5",
      fill: "#fff",
      stroke: "#CCC",
      rx: "3.5",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fill: "#000",
      fillRule: "evenodd",
      d: "M18.99 9.55c.46 0 .85-.3.85-.77 0-.43-.37-.78-.85-.78-.5 0-.85.34-.85.78 0 .47.37.77.85.77ZM6.69 16c1.3 0 2.39-.56 2.39-1.84 0-1.05-.93-1.47-2.26-1.72l-.19-.04-.2-.03-.04-.01c-.44-.1-.9-.24-.9-.64 0-.41.46-.57.9-.57.61 0 1.08.27 1.23.87l1.22-.34c-.32-1.09-1.29-1.61-2.44-1.61-1.17 0-2.23.5-2.23 1.7 0 1.18.95 1.46 1.94 1.66l.07.02h.06c.03.02.07.02.1.03.72.15 1.37.35 1.37.78 0 .5-.54.66-1.02.66-.68 0-1.2-.31-1.4-.95L4 14.32C4.33 15.52 5.53 16 6.7 16Zm12.98-5.81v5.77H18.3v-5.77h1.37ZM15.54 16c.4 0 1.1-.15 1.44-1.13a6.03 6.03 0 0 0 .24-1.81v-.19c.05-.72.15-1.36.4-1.36V10.2c-.4 0-1.15.15-1.5 1.17-.16.5-.2 1.13-.24 1.73v.09l-.05.54v.09c-.05.45-.13.88-.3.88-.16 0-.25-.37-.31-.78l-.01-.04-.02-.12v-.1c-.03-.2-.04-.39-.05-.54a6.9 6.9 0 0 0-.24-1.76c-.33-1-1.07-1.16-1.47-1.16-.41 0-1.13.15-1.47 1.16-.16.5-.2 1.17-.23 1.76 0 .15-.02.35-.04.54v.05c-.06.48-.16.99-.35.99-.19 0-.3-.47-.37-.93l-.01-.04v-.05a7 7 0 0 1-.06-.56c-.03-.84-.05-1.76-.05-2.92H9.51v.3c0 1 0 1.73.05 2.62.05.8.17 1.39.3 1.74.25.77.76 1.15 1.48 1.15a1.5 1.5 0 0 0 1.48-1.15c.15-.52.2-1.13.24-1.74l.01-.17.04-.49v-.05c.06-.44.14-.89.32-.89.17 0 .25.4.3.82v.05l.01.05v.04c.03.2.04.4.05.56v.09c.03.6.06 1.22.24 1.73.33 1 1.09 1.15 1.5 1.15h.01Zm6.18-2.98c0 .93.2 1.52.69 2.17L21.3 16a4.57 4.57 0 0 1-.95-2.98V8.15h1.37v4.87ZM25.24 16c1.31 0 2.18-.77 2.55-1.68l-1.27-.34c-.2.5-.63.8-1.25.8a1.5 1.5 0 0 1-1.5-1.48h4.21c.17-1.73-.85-3.23-2.75-3.23-1.7 0-2.83 1.29-2.83 2.95 0 1.65 1.13 2.98 2.84 2.98Zm-.03-4.81c-.7 0-1.3.44-1.43 1.09h2.86c-.1-.59-.67-1.1-1.43-1.1Z",
      clipRule: "evenodd",
    })
  );
};
Swile32.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "24",
  fill: "none",
  viewBox: "0 0 32 24",
};
const sizeMap = {
  24: Swile24,
  32: Swile32,
};
export function Swile(_ref) {
  let { size = "24" } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const Icon = sizeMap[size] || sizeMap["24"];
  if (
    process.env.NODE_ENV !== "production" &&
    process.env.NODE_ENV !== "test" &&
    !sizeMap[size]
  ) {
    throw new Error(
      "The '".concat(
        size,
        "' size is not supported by the 'Swile' icon. Please use one of the available sizes: '24', '32'."
      )
    );
  }
  return /*#__PURE__*/ React.createElement(Icon, props);
}
